import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';

/**
 * Centred shell for the authentication screens — BUILD-PLAN §25/§45.
 *
 * Deliberately free of the main navigation: sign-in and registration are
 * focused tasks, and the surrounding shop chrome only invites abandonment.
 */

interface AuthLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-5 py-14">
      <Link to="/" aria-label="Glanz Luxe — home">
        <Logo size="md" decorative />
      </Link>

      <main className="mt-10 w-full max-w-md">
        <div className="border border-line bg-surface px-6 py-9 shadow-card sm:px-9">
          <h1 className="font-display text-2xl text-ink">{title}</h1>

          {description && (
            <p className="mt-2 text-sm leading-relaxed text-muted">
              {description}
            </p>
          )}

          <div className="mt-7">{children}</div>
        </div>

        {footer && (
          <div className="mt-6 text-center text-sm text-muted">{footer}</div>
        )}
      </main>

      <p className="mt-10 font-display text-sm italic text-accent">
        Made with Purpose. Packaged with Love.
      </p>
    </div>
  );
}
